import { useAppSelector } from 'Store';

import * as selectors from './selectors';

export const useSelectLoginState = () => useAppSelector(selectors.selectLoginState);
export const useSelectLoginError = () => useAppSelector(selectors.selectLoginError);
export const useSelectRegistrationError = () => useAppSelector(selectors.selectRegistrationError);
export const useSelectResetPasswordError = () => useAppSelector(selectors.selectResetPasswordError);
export const useSelectChangePasswordError = () =>
  useAppSelector(selectors.selectChangePasswordError);
export const useSelectForgotPasswordError = () =>
  useAppSelector(selectors.selectForgotPasswordError);
export const useSelectIsChangePasswordSuccess = () =>
  useAppSelector(selectors.selectIsChangePasswordSuccess);
export const useSelectIsRegistrationSuccess = () =>
  useAppSelector(selectors.selectIsRegistrationSuccess);
export const useSelectIsForgotPasswordSuccess = () =>
  useAppSelector(selectors.selectIsForgotPasswordSuccess);

export const useSelectIsLogged = () => useAppSelector(selectors.selectIsLogged);
export const useSelectIsLoginPending = () => useAppSelector(selectors.selectIsLoginPending);
export const useSelectIsNotLogged = () => useAppSelector(selectors.selectIsNotLogged);
export const useSelectIsLoginRejected = () => useAppSelector(selectors.selectIsLoginRejected);
export const useSelectHasLoginError = () => useAppSelector(selectors.selectHasLoginError);
export const useSelectHasRegistrationError = () =>
  useAppSelector(selectors.selectHasRegistrationError);
export const useSelectHasResetPasswordError = () =>
  useAppSelector(selectors.selectHasResetPasswordError);
export const useSelectHasChangePasswordError = () =>
  useAppSelector(selectors.selectHasChangePasswordError);
export const useSelectCanShowSuccessMessage = () =>
  useAppSelector(selectors.selectCanShowSuccessMessage);
